import {
  BodyText,
  Flex,
  Heading,
  InlineLink,
} from '@utilitywarehouse/hearth-react';
import { type RefObject } from 'react';

import { scrollToFAQTopic } from '@components/FAQ/scrollToTopic';

import { Topics } from '../CashbackFAQ/constants';
import { CashbackCalculatorProvider } from './CalculatorProvider/CalculatorProvider';
import { Earn } from './Earn/Earn';
import { IncludeCashbackSwitch } from './IncludeCashbackSwitch/IncludeCashbackSwitch';
import { Spend } from './Spend/Spend';
import './styles.scss';

interface CalculatorProps {
  formRef?: RefObject<Nullable<HTMLFormElement>>;
  coreServiceCount?: number;
  onFAQLinkClick?: () => void;
  disableCommsRef?: RefObject<Nullable<() => void>>;
}

const Calculator = ({
  formRef,
  coreServiceCount,
  onFAQLinkClick,
  disableCommsRef,
}: CalculatorProps) => {
  return (
    <CashbackCalculatorProvider
      formRef={formRef}
      coreServiceCount={coreServiceCount}
      disableCommsRef={disableCommsRef}
    >
      <Flex
        asChild
        spacing="lg"
        direction="column"
        paddingY={{ mobile: '350', desktop: '500' }}
      >
        <section>
          <Flex asChild spacing="lg" direction="column">
            <header>
              <Heading size="lg" id="cashback-calculator">
                Cashback calculator
              </Heading>
              <BodyText size="sm" color="secondary">
                Estimates are illustrative. Your actual earnings will vary by
                spend and brand.
              </BodyText>
            </header>
          </Flex>
          <IncludeCashbackSwitch />
          <Flex
            direction={{ mobile: 'column', desktop: 'row' }}
            spacing="xl"
            className="cbcCalculator__Calculator"
          >
            <Spend />
            <Earn />
          </Flex>
          <aside className="cbcCalculator__Disclaimer">
            <BodyText size="sm" color="secondary">
              Cashback rates vary. Partner brands offer up to 15% cashback. All
              other spending at non-partner brands earns 1% cashback, up to a
              monthly maximum of £5, £10 or £15 depending on how many bundle
              services you have with us. See{' '}
              {onFAQLinkClick ? (
                <InlineLink asChild>
                  <button
                    onClick={() =>
                      scrollToFAQTopic(Topics.monthlyLimit, onFAQLinkClick)
                    }
                    type="button"
                  >
                    our FAQs
                  </button>
                </InlineLink>
              ) : (
                'our FAQs'
              )}{' '}
              below for more information.
            </BodyText>
          </aside>
        </section>
      </Flex>
    </CashbackCalculatorProvider>
  );
};

export { Calculator };
